require('./expensesByCategoryTable.scss');

const PropTypes = require('prop-types');

// @ vendors
const React = require('react');
const {
    Component
} = require('react');
const { connect } = require('react-redux');

// @ helpers
const { FormattedText, getLanguage } = require('core/i18n').i18n;
const { formatAmountObject, getPlainAmountObject } = require('utilities/currencyHelper');
const { LabelDate } = require('commonsComponents/labelDate');
const { DATE_FORMAT_DAY_MONTH, CATEGORY_TYPE_ACCOUNT } = require('constants/index');
const { getFirstNChars, getLastNChars } = require('utilities/stringHelper');

// @ components
const { OneLineSymbolAmount } = require('commonsComponents/oneLineSymbolAmount');
const { CategoriesModalOld } = require('components/commons/categoriesModal/categoriesModalOld');

// @ commons
const { OKTable } = require('commonsComponents/OKTable');
const { OKTableRow } = require('commonsComponents/OKTableRow');
const { OKTableCell } = require('commonsComponents/OKTableCell');

// @ actions
const { open } = require('actions/categoryUpdate');

// @ constants
const { LABEL_DATE_TODAY, LABEL_DATE_YESTERDAY } = require('constants/commonsComponents');

class ExpensesByCategoryTable extends Component {

    buildColumnsTable() {
        return (
            <thead>
                <OKTableRow asHeader={true}>
                    <OKTableCell asHeader={true}>
                        <FormattedText value="movementsByCategory-date" />
                    </OKTableCell>
                    <OKTableCell asHeader={true}>
                        <FormattedText value="movementsByCategory-contract" />
                    </OKTableCell>
                    <OKTableCell asHeader={true}>
                        <FormattedText value="movementsByCategory-subCategory" />
                    </OKTableCell>
                    <OKTableCell asHeader={true}>
                        <FormattedText value="movementsByCategory-description" />
                    </OKTableCell>
                    <OKTableCell asHeader={true} className="expenses-by-category-row--align-right">
                        <FormattedText value="movementsByCategory-amount" />
                    </OKTableCell>
                    { 
                        this.props.canChangeCategory ?
                            <OKTableCell className="expenses-by-category-row__expand" asHeader={true}>
                                <span></span>
                            </OKTableCell> : null
                    }
                </OKTableRow>
            </thead>
        );
    }

    handleOpenCategoriesModal(expense, index) {
        this.props.openCategoriesModal(
            CATEGORY_TYPE_ACCOUNT,
            expense.get('contractId'),
            index,
            expense.get('categories'),
            expense.get('subCategories'),
            expense.get('concept'),
            expense.get('fecha'),
            expense.get('monto')
        );
    }

    getAccountTypeIcon(type) {
        switch (type) {
            case 0:
                return 'rebrand-accounts';
            default:
                return 'rebrand-credit-card';
        }
    }

    buildContentTable() {
        let isExpanded = false;
        let response = this.props.expensesByCategory.map((expense, index) => {
            const accountTypeIcon = this.getAccountTypeIcon(expense.get('tipoCuenta'));
            const plainAmountObject = getPlainAmountObject({ amount: expense.get('monto'), currency: expense.get('currency') });
            const language = getLanguage();
            let title;

            if( typeof expense.get('description') === 'string') {
                title = getFirstNChars(expense.get('description').trim(), 30);
            }
            else if ( typeof expense.get('description').get('current') === 'string') {
                title = getFirstNChars(expense.get('description').get('current').trim(), 30);
            } else {
                title = "-";
            }

            return (
                <OKTableRow key={index} isExpanded={isExpanded}>
                    <OKTableCell className="expenses-by-category-row__date">
                        <LabelDate
                            date={expense.get('fecha')}
                            format={DATE_FORMAT_DAY_MONTH}
                            language={language}
                            today={LABEL_DATE_TODAY}
                            yesterday={LABEL_DATE_YESTERDAY}
                        />
                    </OKTableCell>
                    <OKTableCell className="expenses-by-category-row__contract">
                        <i className={`expenses-by-category-row__icon icon ${accountTypeIcon}`}
                            onClick={this.props.canChangeCategory ? () => this.handleOpenCategoriesModal(expense, index) : null}
                        />
                        <span className="expenses-by-category-table__contract-title">
                            {
                                title
                            }
                        </span>
                        <span className="expenses-by-category-table__contract-title--small">
                            {
                                getLastNChars(expense.get('contract'))
                            }
                        </span>
                    </OKTableCell>
                    <OKTableCell className="expenses-by-category-row__subcategory">
                        {
                            <FormattedText value={
                                `${expense.get('categories')}-${expense.get('subCategories')}`
                            } />
                        }
                    </OKTableCell>
                    <OKTableCell className="expenses-by-category-row__description">
                        {
                            expense.get('concept')
                        }
                    </OKTableCell>
                    <OKTableCell className="expenses-by-category-row__amount expenses-by-category-row--align-right">
                        <OneLineSymbolAmount
                            amountObject={plainAmountObject}
                            language={language}
                            amountObjectFormatted={formatAmountObject(plainAmountObject, true)} />
                    </OKTableCell>
                    { 
                        this.props.canChangeCategory ? 
                            <OKTableCell className="expenses-by-category-row__expand-button">
                                <div
                                    className="expenses-by-category-row__icon-wrapper"
                                    onClick={() => this.handleOpenCategoriesModal(expense, index)}>
                                    <i className="icon icon-editar expenses-by-category-row__icon-wrapper__icon" />
                                </div>
                            </OKTableCell> : null
                    }
                </OKTableRow>
            );
        });

        return (
            <tbody>
                {response}
            </tbody>
        );
    }

    render() {

        const tableHeader = this.buildColumnsTable();
        const tableBody = this.buildContentTable();

        /**
         * @horizontal-scroll
         *
         * The result table has a container with an horizontal scroll and the
         * inner content is set to a fix width according to its size in
         * desktop.
         */

        return (
            <div style={{ overflowX: 'auto' }}>
                <section className="expenses-by-category-table">
                    <CategoriesModalOld byCategory />
                    <OKTable>
                        {tableHeader}
                        {tableBody}
                    </OKTable>
                </section>
            </div>
        );
    }
}

ExpensesByCategoryTable.propTypes = {
    immAccounts: PropTypes.object.isRequired,
    immCards: PropTypes.object.isRequired,
    expensesByCategory: PropTypes.object.isRequired,
    openCategoriesModal: PropTypes.func,
    canChangeCategory: PropTypes.bool
};

ExpensesByCategoryTable.defaultProps = {
    canChangeCategory: true
}

module.exports = connect(null, {
    openCategoriesModal: open
})(ExpensesByCategoryTable);
